import { convertToHTML, convertFromHTML } from "draft-convert";

export const fromHTML = convertFromHTML({
  htmlToBlock: (nodeName, node) => {
    switch (nodeName) {
      case "figure":
        return { type: "atomic", data: {} };
      case "blockquote":
        return { type: "blockquote", text: node.textContent };
    }
  },
  htmlToEntity: (nodeName, node, createEntity) => {
    switch (nodeName) {
      case "img": {
        const entityKey = createEntity("image", "IMMUTABLE", {
          src: node.src,
          alt: node.alt || "",
          alignment: getAlignmentFromClass(node.className),
          width: Number.parseInt(node.style.width, 10) || undefined
        });
        return entityKey;
      }
      case "a":
        const entityKey = createEntity("LINK", "MUTABLE", { url: node.href });
        return entityKey;
    }
  },
  htmlToStyle: (nodeName, node, currentStyle) => {
    switch (nodeName) {
      case "a":
        return currentStyle.add("LINK");
      default:
        return currentStyle;
    }
  }
});

export const toHTML = convertToHTML({
  blockToHTML: block => {
    if (block.type === "atomic") {
      return {
        start: `<figure>`,
        end: `</figure>`
      };
    }
  },
  entityToHTML: (entity, originalText) => {
    if (entity.type.toLowerCase() === "image") {
      console.log("entity to html, width", entity.data);
      let width = entity.data.width ? entity.data.width + "%" : "auto";
      return `<img src="${entity.data.src}" class = "align-${entity.data.alignment}" style="width: ${width}" alt="${entity.data.alt}" />`;
    }
    if (entity.type.toLowerCase() === "link") {
      console.log("entity to html", entity.data);
      return `<a href="${entity.data.url}" target="_blank" rel="noreferrer">${originalText}</a>`;
    }
  }
});

function getAlignmentFromClass(htmlClass) {
  let alignmentClass = htmlClass.split(" ").find(str => str.includes("align-"));
  if (!alignmentClass) {
    return "default";
  }
  if (alignmentClass.includes("left")) {
    return "left";
  }
  if (alignmentClass.includes("right")) {
    return "right";
  }
  if (alignmentClass.includes("center")) {
    return "center";
  }
  return "default";
}



// WEBPACK FOOTER //
// ./src/utils/customDraftConverters.js